<template>
    <div class="check__container" :class="{'check__text':type=='text'}" :style="mainStyle">
        <label :class="{active:!checked}" v-if="label.before" :for="id">{{ label.before }}</label>
        <input :id="id" type="checkbox" :checked="checked" v-model="checked" @change="changed($event)"  :class="{check:type=='simple'}"  :style="ckeckThem">
        <label :class="{active:checked}" v-if="label.after" :for="id">{{ label.after }}</label>
    </div>
</template>
<script>
export default {
    data() {
        return {
            checked: false,
        }
    },
    props:{
        id: {type: String, default: 'switch' },
        on: { default: true},
        off: { default: false },
        label: {type: Object, default: () => ({before:"", after:""})},
        // labelAfter: {type :Boolean, default : false},
        value: null,
        colors : { type : Object, default : () => ({on : "#43c1cb", off : "#343b43",border:"#333"})},
        background : { type : Object, default : () =>  ({on : "#343b43", off : "#ddd"})},
        margin : { type : Number, default : 0},
        type : { type : String, default : 'simple'}
    },
    mounted() {
        // this.switchId = this.label.toLowerCase().replace(/ /gi, '_');
        this.checked = this.value == this.on;
    },
    computed : { 
        ckeckThem(){
            return {
                '--bulletOn' : this.colors.on,
                '--bulletOff' : this.colors.off,
                '--bgOn' : this.background.on,
                '--bgOff' : this.background.off,
                '--borderColor' : this.colors.border
            }
        },
        mainStyle(){
            return {
                margin : this.margin
            }
        }
    },
    methods: {
        changed(e){
            if(this.type != 'text'){
                if(e.target.checked) this.$emit('input',this.on);
                else this.$emit('input',this.off);
            }else{
                if(e.target.checked) this.$emit('input',this.label.after);
                else this.$emit('input',this.label.before);
            }
        }
    },
}
</script>
<style lang="scss" scoped>
    :root {
        --bulletOn : #43c1cb;
        --bulletOff : #343b43;
        --bgOn : #343b43;
        --bgOff : #ddd;
        --text-color : #333;
        --borderColor : #222222;
    }
    .check__container {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .check{
    cursor: pointer;
    position: relative;
    height: 0;
    width: 40px;
    height: 20px;
    }
    .check::before{
    content: '';
    position: absolute;
    width: 40px;
    height: 20px;
    background-color: var(--bgOff);
    display: inline-block;
    top: 0px;
    left: 0px;
    border-radius: 25px;
    box-shadow: 0 0 0 2px #00000010;
    }
    .check::after{
    content: '';
    width: 20px;
    height: 20px;
    background-color: var(--bulletOff);
    position: absolute;
    top: 0px;
    border-radius: 25px;
    left: 1px;
    transition: 200ms;
    }

    .check:checked::after{
    left: 20px;
    background-color:var(--bulletOn);
    }
    .check:checked::before{
    background-color: var(--bgOn);
    box-shadow: 0 0 0 2px rgba(60, 130, 240, 0.3);
    }

    .check__text {
        position: relative;
        border: 2px solid;
        border-color: var(--border-color);
        margin : 0 1rem !important;
        border-radius: .2rem;
        input[type=checkbox] {
            visibility: hidden;
            position: absolute;
        }
        label {
            text-align: center;
            margin : 0;
            padding : .2rem .4rem;
            min-width: 3.5rem;
            background-color: #ffffff;
            color : #333;
            cursor: pointer;
        }
        
    }
    .active {
        background-color: #333 !important;
        color : #ffffff !important;
    }
    
</style>


// WEBPACK FOOTER //
// src/components/global/Toggle.vue